import { ScreeningVerdict } from '../manage-brief-tabs-screen/data/screening-results.model';

/**
 * Report copy, verbatim from the design handover.
 *
 * Kept in one file so it can be diffed against the handover rather than hunted through templates.
 */
export const VERDICT_LINE: Record<ScreeningVerdict, (ctx: VerdictContext) => string> = {
  passed: (ctx) =>
    `Every piece of content evaluated met all ${ctx.rulesTotal} rules in the brief. No action needed.`,
  flagged: (ctx) =>
    `Content met most of the brief, but ${ctx.flaggedItems} item${ctx.flaggedItems === 1 ? '' : 's'} breached a rule and ${ctx.flaggedItems === 1 ? 'is' : 'are'} waiting on your decision.`,
  failed: () =>
    "A mandatory requirement was not delivered. This creator's content does not satisfy the brief as submitted.",
  progress: (ctx) =>
    `${ctx.evaluated} of ${ctx.total} items have been evaluated. This report will finalise once screening completes.`,
  queued: () => 'Screening has not started yet. No content has been evaluated against the brief.',
};

export interface VerdictContext {
  rulesTotal: number;
  flaggedItems: number;
  evaluated: number;
  total: number;
}

/** The four report sections that have no data source yet. */
export const PLACEHOLDER_SECTIONS: readonly {
  heading: string;
  description: string;
  lineWidths: number[];
  caption: string;
}[] = [
  {
    heading: 'Executive summary',
    description: 'A written read on how this creator performed against the brief.',
    lineWidths: [100, 94, 88, 62],
    caption:
      "The generated summary will go here — two or three paragraphs written from the rule results, the flags raised and the creator's posting history.",
  },
  {
    heading: 'Sentiment analysis',
    description: 'How audiences responded across captions and comments.',
    lineWidths: [100, 78, 90],
    caption:
      'Comment sentiment breakdown, recurring themes and any audience reaction worth flagging to the brand.',
  },
  {
    heading: 'Audience and reach',
    description: 'Who this creator actually reaches.',
    lineWidths: [100, 84],
    caption:
      'Follower demographics, location split against the brief target, and delivered reach per item.',
  },
  {
    heading: 'Recommendation',
    description: 'What we suggest you do with this creator.',
    lineWidths: [100, 70],
    caption:
      'A recommended next action — approve, request changes, or remove from the programme — with the reasoning behind it.',
  },
];

export const MEDIA_COMING_SOON = {
  heading: 'Media Library Coming Soon',
  body:
    'Every asset this creator produced — raw video, stills and screen recordings — collected in one place, ready to download or push into a campaign.',
} as const;
